/***
 * TypeScript Entry Point
 * @author Arthur Moore <ArthurMO@mohela.com>
 * @copyright MOHELA 2024
 ***/

import 'vite/modulepreload-polyfill' // Required when using Backend Integration mode
import '@/main.js';
import './app.scss';

import { run } from '@/main.js';
import { convertKFText } from '@/common/convertToISA.js';

//@todo: Hack
(window as any).isISA = true;

console.log("isa_bff")
convertKFText(window.location.host);
run();
